import { Box, Button, Grid2, Paper, Typography } from "@mui/material";
import ConfirmDialog from "components/common/ConfirmDialog";
import FilmReleaseSelect from "components/common/FilmReleaseSelect";
import { FilmCardView } from "components/film";
import { get } from "lodash";
import log from "loglevel";
import React, { useCallback, useEffect } from "react";

function areEqual(prevProps, nextProps) {
    return prevProps.filmReleaseId === nextProps.filmReleaseId;
}


const ReadOnlyForm = React.memo(({ filmRelease }) => {
    const enteredDate = get(filmRelease, "enteredDateFormatted", null);
    const releaseDate = get(filmRelease, "releaseDateFormatted", null);
    const ratingType = get(filmRelease, "filmRatingTypeId.abbreviation", null);
    const deliverySystem = get(filmRelease, "deliverySystem", null);
    const title = get(filmRelease, "title", "");
    const company = get(filmRelease, "companyId.name", "");
    const releaseTypeName = get(filmRelease, "filmReleaseTypeId.name", null);

    const labelGrid2 = {
        xs: 5,
        md: 3,
        lg: 3,
        xl: 2,
    };
    const valueGrid2 = {
        xs: 7,
        md: 8,
        lg: 9,
        xl: 10,
    };
    return (
        <Box style={{ marginTop: 2 }}>
            <Grid2 container spacing={1}>
                <Grid2 size={labelGrid2}>
                    <Typography variant={"subtitle1"}>Film Title</Typography>
                </Grid2>
                <Grid2 size={valueGrid2}>
                    <Typography variant={"subtitle2"}>{title}</Typography>
                </Grid2>
                <Grid2 size={labelGrid2}>
                    <Typography variant={"subtitle1"}>Company</Typography>
                </Grid2>
                <Grid2 size={valueGrid2}>
                    <Typography variant={"subtitle2"}>{company}</Typography>
                </Grid2>

                <Grid2 size={labelGrid2}>
                    <Typography variant={"subtitle1"}>Release</Typography>
                </Grid2>
                <Grid2 size={valueGrid2}>
                    <Typography variant={"subtitle2"}>{releaseTypeName}</Typography>
                </Grid2>
                <Grid2 size={labelGrid2}>
                    <Typography variant={"subtitle1"}>Release Date</Typography>
                </Grid2>
                <Grid2 size={valueGrid2}>
                    <Typography variant={"subtitle2"}>{releaseDate}</Typography>
                </Grid2>
                <Grid2 size={labelGrid2}>
                    <Typography variant={"subtitle1"}>Entry Date</Typography>
                </Grid2>
                <Grid2 size={valueGrid2}>
                    <Typography variant={"subtitle2"}>{enteredDate}</Typography>
                </Grid2>

                <Grid2 size={labelGrid2}>
                    <Typography variant={"subtitle1"}>Rating</Typography>
                </Grid2>
                <Grid2 size={valueGrid2}>
                    <Typography variant={"subtitle2"}>{ratingType}</Typography>
                </Grid2>

                <Grid2 size={labelGrid2}>
                    <Typography variant={"subtitle1"}>Vendor</Typography>
                </Grid2>
                <Grid2 size={valueGrid2}>
                    <Typography variant={"subtitle2"}>{deliverySystem}</Typography>
                </Grid2>
            </Grid2>
        </Box>
    );
}, areEqual);

const FilmImport = ({ filmRelease, onSubmitMatch }) => {
    const filmReleaseId = get(filmRelease, "id", null);
    const [showConfirm, setShowConfirm] = React.useState(false);
    const [id, setId] = React.useState(filmReleaseId);
    const [selectedFilm, setSelectedFilm] = React.useState(null);
    get(filmRelease, "title", "");
    const selectedId = selectedFilm ? selectedFilm.id : null;

    useEffect(() => {
        if (filmReleaseId) {
            setId(filmReleaseId);
        }
    }, [filmReleaseId]);

    useEffect(() => {
        if (id !== filmReleaseId || !filmReleaseId) {
            setId(filmReleaseId);
            setSelectedFilm(null);
        }
    }, [filmReleaseId, id]);

    function handleConfirmAccept() {
        setShowConfirm(false);
        onSubmitMatch(selectedId, filmReleaseId);
    }

    function handleConfirmCancel() {
        setShowConfirm(false);
    }

    function onChangeFilmRelease(film) {
        log.debug(film);
        setSelectedFilm(film);
    }
    const handleMatchClick = useCallback(() => {
        if (filmReleaseId && selectedId) {
            setShowConfirm(true);
        }
    }, [filmReleaseId, selectedId]);

    const btnContainer = React.useMemo(() => {
        return (
            (<Grid2 size={12}>
                <Button
                    color={"primary"}
                    onClick={handleMatchClick}
                    disabled={!(filmReleaseId && selectedId)}
                    variant={"contained"}
                    type={"submit"}
                >
                    {" "}
                    Accept
                </Button>
            </Grid2>)
        );
    }, [filmReleaseId, handleMatchClick, selectedId]);

    return (
        (<Paper style={{ width: "100%", padding: 15, paddingTop: 10, paddingBottom: 10 }}>
            <ConfirmDialog
                open={showConfirm}
                message="Accept Film Release confirmation"
                confirmText="Accept"
                closeText="Cancel"
                onConfirm={handleConfirmAccept}
                onCancel={handleConfirmCancel}
            />
            <Grid2 container spacing={2} alignItems={"flex-start"} alignContent={"flex-start"}>
                <Grid2
                    paddingLeft={2}
                    size={{
                        xs: 12,
                        md: 6
                    }}>
                    <Box style={{ width: "100%" }}>
                        <Typography variant={"h6"} gutterBottom>
                            External Submission
                        </Typography>
                        <ReadOnlyForm filmReleaseId={filmReleaseId} filmRelease={filmRelease} />
                    </Box>
                </Grid2>

                <Grid2
                    size={{
                        xs: 12,
                        md: 6
                    }}>
                    <Box style={{ width: "100%" }}>
                        <Typography variant={"h6"} gutterBottom>
                            Internal Match
                        </Typography>
                        <Grid2 container spacing={4}>
                            <Grid2 size={12}>
                                <FilmReleaseSelect keepInputText value={selectedFilm} onChange={onChangeFilmRelease} />
                            </Grid2>
                            <Grid2 size={12}>
                                <FilmCardView
                                    expandPanelClassName={"root"}
                                    defaultExpanded={false}
                                    loadFilmReleaseId={selectedId}
                                    filmRelease={selectedFilm}
                                />
                            </Grid2>
                            {btnContainer}
                        </Grid2>
                    </Box>
                </Grid2>
            </Grid2>
        </Paper>)
    );
};

export default FilmImport;
